const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-red-100">
      <h1 className="text-4xl font-bold text-red-600">404 - Page Not Found</h1>
    </div>
  );
};

export default NotFound;
